import type { SelectOption } from '@components/Select/select.types';

export const getSelectedOptions = (
  options: SelectOption[],
  values: string[],
): SelectOption[] => options.filter((option) => values.includes(option.value));

export const getMultiSelectDisplayText = (
  selectedOptions: SelectOption[],
  placeholder?: string,
): string =>
  selectedOptions.length > 0
    ? selectedOptions.map((option) => option.label).join(', ')
    : (placeholder ?? '');

export const toggleMultiSelectValue = (
  values: string[],
  nextValue: string,
): string[] =>
  values.includes(nextValue)
    ? values.filter((value) => value !== nextValue)
    : [...values, nextValue];
